import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import React from 'react';
import type { VideoAsset } from '../../../services/admin/adminBackendServiceVideoLibraryMixin';

interface DeleteVideoDialogProps {
  video: VideoAsset | null;
  onCancel: () => void;
  onConfirm: (force: boolean) => void;
}

/** Blocks (with the reference list) if the video is still linked into content; otherwise a plain confirm. */
export default function DeleteVideoDialog({ video, onCancel, onConfirm }: DeleteVideoDialogProps) {
  if (!video) return null;
  const inUse = (video.referenceCount ?? 0) > 0;

  return (
    <Dialog open onClose={onCancel} maxWidth="xs" fullWidth aria-labelledby="delete-video-title">
      <DialogTitle id="delete-video-title">Delete “{video.title}”?</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {inUse
            ? `This video is still used in ${video.referenceCount} place${video.referenceCount === 1 ? '' : 's'}. Deleting it will break that content.`
            : 'This removes the video and its compressed copy. This can’t be undone.'}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="inherit">
          Cancel
        </Button>
        <Button
          onClick={() => onConfirm(inUse)}
          variant="contained"
          color={inUse ? 'warning' : 'error'}
        >
          {inUse ? 'Delete anyway' : 'Delete'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
